// Components==============
import React from 'react';
import './TrainingLayout.module.scss';
// =========================

export default function TrainingLayout({
  content,
  menu,
}: {
  content: React.ReactNode;
  menu: React.ReactNode;
}) {
  return (
    <div styleName="wrapper">
      <div styleName="content">{content}</div>
      <div styleName="menu">{menu}</div>
    </div>
  );
}
